module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_library.js
// module id = 114
// module chunks = 0